import { createContext } from 'react';
import { TenantContextValue } from '@/types/tenant';

export const TenantContext = createContext<TenantContextValue | null>(null);